document.addEventListener('DOMContentLoaded', ()=>{
    // if (document.querySelector('.productInfo__single__media_nt.swiper')) {
    //     const thumbsSwiper = new Swiper('.productInfo__single__thumbs.swiper', {
    //         slidesPerView: 'auto',
    //         direction: 'vertical',
    //         spaceBetween: 10,
    //         watchSlidesProgress: true,            
    //     });    
    //     new Swiper('.productInfo__single__media_nt.swiper', {
    //         slidesPerView: 1,
    //         spaceBetween: 6,            
    //         navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    //         thumbs: { swiper: thumbsSwiper }
    //     });
    // }

    if (document.querySelector('.productInfo__single__media_nt.swiper')) {
  new Swiper('.productInfo__single__media_nt.swiper', {
    slidesPerView: 1,
    spaceBetween: 6,
    loop: true,

    navigation: {
      nextEl: '.productInfo__single__pagination .swiper-button-next',
      prevEl: '.productInfo__single__pagination .swiper-button-prev'
    }
  });
}

    const collapsibleTab = (target)=>{
        target.target.closest('[js-collapsible-outer]').classList.toggle('active');
        if ( target.target.closest('[js-collapsible-outer]').classList.contains('active') ){
        let HeightElementData = target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]');
        target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = `${HeightElementData.scrollHeight}px`;
        }else{
        target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = null;
        }              
    }
    document.querySelectorAll('[js-collapsible-header]').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
        target.preventDefault();
        if( target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && window.screen.width < 750 && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTab(target);
        }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTabOpenTime(target);
        }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTab(target);
        }
        })
    }); 

    class PurchaseSelectionBubble extends HTMLElement {
        constructor() {
            super();
            this.attachEvents();
        }
        attachEvents() {
            this.querySelectorAll(`.bubbleSwatch__element_interior`).forEach((elm)=>{
                elm.querySelector(`label`).addEventListener('change', () => {
                    this.syncVariants();
                });
            });
            this.defaultSelected = this.querySelector('.bubbleSwatch__interior').firstChild.querySelector('input');
            this.defaultSelected.click();
            this.defaultSelectedClick = new Event('click', { bubbles: true, cancelable: true });
            this.defaultSelected.dispatchEvent(this.defaultSelectedClick);            
        }
        syncVariants() {
            this.selectedValue();
            this.selectMasterVariant(this.choosedOneTime);
            this.UpdateAppearance();
        }
        selectedValue() {
            this.choosedOneTime = [...this.querySelectorAll('.bubbleSwatch__element_interior input:checked')].map(input => input.value);
        }
        getVariantData() {
            return this.variantData ||= JSON.parse(this.querySelector('[type="application/json"]').textContent);
        }
        selectMasterVariant(choices) {
            this.currentVariant = this.getVariantData().find(variant =>
            !variant.options.some((opt, idx) => opt !== choices[idx])
            );
        }
        renderProductInfo(requestUrl) {
            fetch(requestUrl)
            .then(response => response.text())
            .then(htmlString => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');
                const SectionId = doc.querySelector('.mainProduct__layoutwp').dataset.section;
                const sectionPriceEl = doc.querySelector(`[data-widget-price="priceEl-${SectionId}"]`).innerHTML;
                const sectionBadgeEl = doc.querySelector(`[data-badge="badge-El-${SectionId}"]`).innerHTML;
                const sectionButtonEl = doc.querySelector(`[data-button="button-El-${SectionId}"]`).innerHTML;
                document.querySelector(`[data-widget-price="priceEl-${SectionId}"]`).innerHTML = sectionPriceEl;
                document.querySelector(`[data-badge="badge-El-${SectionId}"]`).innerHTML = sectionBadgeEl;
                document.querySelector(`[data-button="button-El-${SectionId}"]`).innerHTML = sectionButtonEl;
            })
            .catch(err => {
                console.error("Drawer fetch error:", err);
            });
        }        
        UpdateAppearance() {
            this.submitBtns = document.querySelectorAll(`.mainProduct__addbutton.product-form__submit[type="submit"]`);
            if (!this.currentVariant) return;
            this.isAvailable = this.currentVariant.available;
            this.soldOut = !this.isAvailable;
            [...this.submitBtns].forEach(btn => {
                this.label = btn.querySelector('span');
                if( this.soldOut == true ){
                   this.label.innerHTML = window.variantStrings.soldOut;
                }else{
                   this.label.innerHTML = window.variantStrings.addToCart;
                }
                btn.disabled = this.soldOut;
            });
            this.closest('.productInfo__singleLayout__ct_interior').querySelector('.productMain__buybuttons_main').querySelector('[name="id"]').value = this.currentVariant.id;
            this.productHandle = document.querySelector('.mainProduct__layoutwp')?.dataset.url;
            if (this.productHandle) {
                window.history.replaceState(null, '', `${this.productHandle}?variant=${this.currentVariant.id}`);
                this.renderProductInfo(`${this.productHandle}?variant=${this.currentVariant.id}`);
            }
        }
    }
    customElements.define('cus-bubble-swatch', PurchaseSelectionBubble);

    const moreButtons = document.querySelectorAll('.product-description-cv .more');
    if (moreButtons.length > 0) {
        moreButtons.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
            e.preventDefault();
            this.textContent = (this.textContent.trim() === 'Voir moins')
                ? 'Voir plus'
                : 'Voir moins';
                const moreCont = this.parentElement.querySelector('.more-cont');
                if (moreCont) {
                    moreCont.style.display = (moreCont.style.display === 'block') ? 'none' : 'block';
                }
            });
        });
    }

})